module.exports = "<div layout=column layout-align=\"center center\"> <h1 style=color:#fff>Board Cloud Administration</h1> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/instance-settings/instance-settings.html
// module id = ./app/instance-settings/instance-settings.html
// module chunks = 8